import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Loading } from "../../components/Loading";
import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { DefaultButton, MyModalBody } from "../../style/default";

const DeleteUpdateModal = ({ open, data, handleUpdates }) => {
	const { handleOpenModal } = useContext(ModalContext);

	const [isLoading, setIsLoading] = useState(false);

	const handleDeleteUpdate = async () => {
		try {
			setIsLoading(true);
			await authApi.delete(`/updates/${data._id}`);
			setIsLoading(false);
			handleUpdates();
			handleOpenModal();
		} catch (error) {
			console.log(error);
			setIsLoading(false);
			handleOpenModal();
		}
	};

	return (
		<Modal
			show={open}
			onHide={handleOpenModal}
			size="lg"
			backdrop="static"
			animation={false}
		>
			{isLoading ? <Loading /> : null}
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Excluir: {data.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<span style={{ fontSize: 18 }}>
						Deseja realmente deletar a atualização: {data.title}?
						<div>
							Essa ação é <span style={{ color: "red" }}>irreversível.</span>
						</div>
					</span>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleDeleteUpdate}>Deletar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
};

export { DeleteUpdateModal };
